export default "__VITE_ASSET__CuCWKgbL__"